<template>
  <b-modal
    id="confirmationmsg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="confirmModal"
    @hidden="btnName === 'Cancel' ? closeModal() : $emit('close-confirm')"
  >
    <div>
      <div class="d-flex w-100">
        <div style="width: 15%">
          <img :src="imageSrc" />
        </div>

        <div class="" style="width: 85%">
          <div class="d-flex justify-content-between align-items-center">
            <div class="confirm-text">
              {{ header }}
            </div>

            <div>
              <img
                @click="
                  btnName === 'Cancel' ? closeModal() : $emit('close-confirm')
                "
                src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
                alt=""
                class="pointer rotate-on-hover"
              />
            </div>
          </div>
          <div class="msg-text mt-2">
            <span v-html="msg"></span>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end mt-3 bluebtn">
        <b-button
          v-if="!hideCancel"
          class="acs-cancelBtn-modal pointer mr-4"
          @click="btnName === 'Cancel' ? closeModal() : $emit('save-draft')"
        >
          {{ btnName }}
        </b-button>

        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal"
            :class="
              showButtonLoader
                ? 'confirm-loader-class defaultCursor'
                : 'pointer'
            "
            @click="!showButtonLoader ? submitForm() : ''"
          >
            {{ showButtonLoader ? "" : button }}
          </b-button>
          <div v-if="showButtonLoader" class="confirm-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import Loader from "@/components/fixedcomponents/Loader.vue";
export default {
  name: "ConfirmModal",
  props: {
    hideCancel: Boolean,
    confirmModal: Boolean,
    header: String,
    imageSrc: String,
    button: String,
    msg: String,
    showButtonLoader: Boolean,
    from: String,
    btnName: {
      type: String,
      default: "Cancel",
    },
  },
  components: {
    Loader,
  },
  methods: {
    closeModal() {
      if (this.$route.name === "InternalHiringDashboard") {
        this.$emit("closeModal");
      } else if (this.header === "Delete Document" || this.from == "bookmark") {
        this.$emit("close-modal");
      } else {
        this.$bvModal.hide("confirmationmsg");
      }
    },
    submitForm() {
      if (this.button == "Discard") {
        this.$emit("confirmButton", true);
      }
      this.$emit("handle-submit");
    },
  },
};
</script>
<style scoped>
.confirm-text {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
.msg-text {
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 500;
  word-break: break-word;
}
</style>
